import React from 'react'

const InlineLink = ({ children, ...rest }) => (
  <a target="_blank" className="underline underline-offset-[3px]" {...rest}>
    {children}
  </a>
)

export default InlineLink
